import React, { Component } from 'react'
import {connect} from 'react-redux'
import { Link, withRouter } from 'react-router-dom';
import FaDiamond from 'react-icons/lib/fa/diamond'
import Arrow from 'react-icons/lib/io/android-arrow-forward';
import RippleLink from '../../../ripplelink';
import style from './style.css';
import withHomeResorts from '../../../../containers/homeresorts';
import withMedia from '../../../../containers/withmedia';
import SectionTitle from '../../../resorthome/sectiontitle';
import topics from '../topics.js'
import * as Actions from '../../../../store/reducers'

//{{{ CardItem
const CardItem = withRouter(({card, history}) => {
  // const photo_url = card.photo_uri.replace("http://media.kenanaonline.com/","")
  // const [_, folder, image, file] = photo_url.split("/").slice(0,4)
  // const photo_uri = `https://media.kenanaonline.com/photos/${folder}/${image}/medium_${file}`
  const photo_uri = card.medium_photo_uri
    return (
      <div className={ style.innerSlide }
            onClick={ () => history.push(`/posts/${card.id}`)}
      >
          <div 
            className={ style.img } 
            style={ { backgroundImage: `url('${ photo_uri }')` }}  > 
                <span   className={[ style.goto, style.turquoise ].join(" ")}>
                    <Arrow/>
                </span>
            </div>
            <div className={ [ style.itemTitle, style.textTurquoise ].join(" ") }>
              <span>{ card.title }</span>
            </div>
            <div className={ style.blurb }>
                { card.blurb }
            </div> 
        </div>
    )
})
//<div  href="/" className={ style.slideTitle}><span className={ style.uptitle }>{ t1 }</span><span className={ style.subtitle }>{ card.short }</span></div>
//}}}
class ScrollingResorts extends Component {
  constructor(props){
      super(props)
      this.state = {posts: null}
  }
    componentWillMount() {
      const { dispatch, topics, topic, topics_loading } = this.props
      const posts = topics && topics[topic.id]
      // const not_loading = Array.isArray(topics_loading) && !topics_loading.includes(topic)
      // console.log({topics_loading, posts})
      console.log({topic})
      if(!posts){
        dispatch(Actions.getTopicPosts({ topic_id: topic }))
      }
    }
    render() {
        const topic_id = this.props.topic
        const topics_posts = this.props.topics
        const items = topics && topics_posts[topic_id]
        const topic = topics.find(topic => topic.id === topic_id) 
        const title = topic && topic.title
        const item_width = this.props.browser.lessThan.extraSmall ? 240 : 300 ;
        const windowWidth = "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
        //const scroll_width = items ? ( Object.keys(items).length * (item_width + 10)) + 14  : 500
        //const scroll_width = items ? ( Object.keys(items).length * 100)  : 100
        const scroll_width = items ? ( Object.keys(items).length * windowWidth)  : windowWidth
        let slides = []
        slides = items
            ? Object.keys(items).map( (k) => 
            <div key={items[k].id} className={ `${style.slide}` } >
              <RippleLink url={`/topics/${topic_id}/posts/${items[k].id}`} styles={{ flex:1, display:'flex'}}>
                    <CardItem card={items[k]} />
                </RippleLink>
            </div>
                ) 
            : <div></div>;
        return (
            <div className={ style.resorts }>
                <SectionTitle title={ title }/>
                <h4 className={ style.subtitle }>{ this.props.title }</h4>
                <div className={ style.scroller } style={{ WebkitScrollSnapPointsX: `repeat(${ windowWidth - 38}px)`, scrollBehavior: 'smooth' }}>
                    {items &&
                    <div style={{ /* width: `${scroll_width}px` */ display: 'flex', flexFlow: 'row nowrap'}} >
                        {slides}
                    </div>
                    }
                </div>
            </div>
        )
    }
}
                // <ScrollBox style={{height: '200px'}} axes={ScrollAxes.X} fastTrack={FastTrack.PAGING}>
                // </ScrollBox>


export default withMedia(connect(s => (
  { highlights: s.app.highlights
  , topics: s.app.topics
  , topics_loading: s.app.topics_loading
  }) )(ScrollingResorts))



// WEBPACK FOOTER //
// ./src/components/homescreen/resorts/scrollingresorts/index.js